import { StackProps, VStack } from "@chakra-ui/react";

interface Props extends StackProps {
  children?: any;
}

export const LimitWidthContainer = ({ children, ...rest }: Props) => {
  return (
    <VStack
      className="limit-width-container"
      w={"100%"}
      maxW={"2560px"}
      p={0}
      mx={"auto"}
      {...rest}
    >
      {children}
    </VStack>
  );
};
